import React from "react";
import logo from "../assets/images/logo.png";

export default function AppHeader({ title, onLogout }) {
  return (
    <header className="bt-app-header">
      <div className="bt-app-header-brand">
        <img src={logo} alt="OPOS Logo" className="bt-app-header-logo" />
        <span className="bt-app-header-divider" />
        <h1 className="bt-app-header-title">{title}</h1>
      </div>
      <button type="button" className="bt-btn bt-btn-secondary" onClick={onLogout}>
        Logout
      </button>
    </header>
  );
}
